import { JsonRange } from 'Editor/services/_Common/Selection';
import { RemoveStylesCommand } from './RemoveStylesCommand';
import { Logger } from '_common/services';

export class ClearFormatCommand extends RemoveStylesCommand {
  private clearFormatOptions: Editor.Edition.ClearFormatCommandOptions;

  constructor(
    context: Editor.Edition.Context,
    rangeToClear?: Editor.Selection.JsonRange,
    options: Editor.Edition.ClearFormatCommandOptions = {},
  ) {
    super(context, {}, rangeToClear);
    this.clearFormatOptions = {
      untrackedActionWarning: true,
      applySelection: true,
      createPatch: true,
      expandWord: true,
      resetParagraphStyle: true,
      ...options,
    };
  }

  protected async handleExec(...args: any[]): Promise<void> {
    if (this.context.debug) {
      Logger.trace('ClearFormatCommand exec', this);
    }

    if (!this.context.DataManager || !this.context.stylesManager) {
      return;
    }

    if (this.clearFormatOptions.untrackedActionWarning && !this.askUserAboutThis()) {
      return;
    }

    if (!this.rangeToApply) {
      const rangeData = this.context.DataManager.selection.current;
      this.rangeToApply = JsonRange.buildFromRangeData(rangeData[0]);

      if (this.rangeToApply.collapsed && this.clearFormatOptions.expandWord) {
        this.context.selection?.modifiers?.modify(this.rangeToApply, 'move', 'word', 'backward');
        this.context.selection?.modifiers?.modify(this.rangeToApply, 'expand', 'word', 'forward');
      }
    }

    const styles = this.context.stylesManager.getStylesAppliedToSelection(this.rangeToApply, {
      includeInlineStyleFromBlock: true,
    });

    this.stylesToRemove = styles;
    this.options = {
      applySelection: this.clearFormatOptions.applySelection,
      createPatch: this.clearFormatOptions.createPatch,
      resetParagraphStyle: this.clearFormatOptions.resetParagraphStyle,
    };

    return super.handleExec(...args);
  }
}
